module.exports = __webpack_public_path__ + "static/img/1-4.2ca2359.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/user-center/my-focus/1-4.jpg
// module id = GaXW
// module chunks = 1